//------------------------------------------------------------------------
// This file contains site-wide JS that will be packaged into a single file
//------------------------------------------------------------------------
/* globals require */// JSHint global vars
'use strict';

// Expose jQuery globally (optional)
window.$ = window.jQuery = require('jquery');

import '../lib/polyfills';

// Picture element polyfill
// Requires background-picture.js and ".js-background-image" CSS in _base.scss
// Can remove once support is broad enough http://caniuse.com/#feat=picture
import 'picturefill';

// Modules
import '../modules/analytics';
import '../modules/background-picture';
import '../modules/custom-select';
import '../modules/form-validation';
import '../modules/jump-links';
import '../modules/mailto';
import '../modules/orphans';
import '../modules/vimeo';
import '../modules/youtube';

// Project specific modules
import '../modules/donut';
import '../modules/page-nav';

// Vue Orchestrator
import '../vue/main';



// WEBPACK FOOTER //
// ./app/javascript/packs/main.js